// extracted by mini-css-extract-plugin
export var chevron = "_2r-2";
export var chevronCollapsed = "_2r-3";
export var collapsibleHeader = "_2r-1";
export var container = "_2r-0";